import { render, staticRenderFns } from "./AccountList.vue?vue&type=template&id=2f974f03&scoped=true&"
import script from "./AccountList.vue?vue&type=script&lang=js&"
export * from "./AccountList.vue?vue&type=script&lang=js&"
import style0 from "./AccountList.vue?vue&type=style&index=0&id=2f974f03&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f974f03",
  null
  
)

export default component.exports